import { useMemo } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { IEvent } from '../../../types'
import MonthlyEvent from '../MonthlyCalendar/MonthlyEvent'

interface IProps {
  events?: IEvent[]
  selectedDate?: Date
  onEventDetail?: (event: IEvent) => void
  eventDetail?: {event: IEvent | null, date: Dayjs} | null
  setEventDetail?: (params: {event: IEvent | null, date: Dayjs}) => void
}

const ListEventInDayMobile = ({
  events = [],
  selectedDate = new Date(),
  onEventDetail,
  eventDetail,
  setEventDetail
}: IProps) => {
  const eventsInDay = useMemo(() => {
    const targetDate = dayjs(selectedDate)
    return events.filter((event) => {
      const eventDate = dayjs(event.startDate)
      return eventDate.isSame(targetDate, 'day')
    })
  }, [events, selectedDate])

  if (eventsInDay.length === 0) {
    return (
      <div className="h-full">
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-2 h-full">
      {eventsInDay.map((event) => (
        <MonthlyEvent
          key={event.id}
          event={event}
          isSameMonth={true}
          onEventDetail={onEventDetail}
          isOnDetail={event.id === eventDetail?.event?.id}
          setEventDetail={setEventDetail}
          date={dayjs(selectedDate)}
        />
      ))}
    </div>
  )
}

export default ListEventInDayMobile
